const DESCRIPTIONS = {
    es: {
        BAND: "Seleccionar la banda a emplear. Automático, Preferido 4G, Preferido 2G, Solo 4g, Solo 2g",
        PIN: "PIN de la tarjeta SIM para su desbloqueo. (Código de 4 dígitos)",
        APN_NAME: "Nombre del APN a utilizar. (desactivar -1)",
        APN_USER: "Usuario del APN a utilizar. (desactivar -1)",
        APN_PASS: "Contraseña del APN a utilizar. (desactivar -1)",
        PREFERENCE_SIM: "Seleccionar la preferencia de SIM a utilizar. SIM 0 (chip), SIM 1 (zócalo externo)"
    },
    en: {
        BAND: "Select the band to use. Automatic, Preferred 4G, Preferred 2G, Only 4g, Only 2g",
        PIN: "PIN of the SIM card for unlocking. (4-digit code)",
        APN_NAME: "Name of the APN to use. (deactivate -1)",
        APN_USER: "User of the APN to use. (deactivate -1)",
        APN_PASS: "Password of the APN to use. (deactivate -1)",
        PREFERENCE_SIM: "Select the SIM preference to use. SIM 0 (chip), SIM 1 (external SIM)"
    }

};
const translations = {
    es: {
        // QT-2G
        "pin": "PIN",
        "pin.description": "PIN de la tarjeta SIM para su desbloqueo. (Código de 4 dígitos)",
        "apn_name": "Nombre de APN",
        "apn_name.description": "Nombre del APN a utilizar. (desactivar -1)",
        "apn_user": "Usuario de APN",
        "apn_user.description": "Usuario del APN a utilizar. (desactivar -1)",
        "apn_pass": "Contraseña de APN",
        "apn_pass.description": "Contraseña del APN a utilizar. (desactivar -1)",
        // MQ2-4G
        "preference_sim": "Preferencia SIM",
        "preference_sim.description": "Seleccionar la preferencia de SIM a utilizar. SIM 0 (chip), SIM 1 (zócalo externo)",
        "preference_sim.choices.preference_sim0": "Preferido SIM0",
        "preference_sim.choices.preference_sim1": "Preferido SIM1",
        "preference_sim.choices.only_sim0": "Solo SIM0",
        "preference_sim.choices.only_sim1": "Solo SIM1",
        "sim0_band": "Banda",
        "sim0_band.description": DESCRIPTIONS.es.BAND,
        "band.choices.auto": "Automático",
        "band.choices.preferred4g": "Preferido 4G",
        "band.choices.preferred2g": "Preferido 2G",
        "band.choices.only4g": "Solo 4g",
        "band.choices.only2g": "Solo 2g",
        "sim0_pin": "PIN",
        "sim0_pin.description": DESCRIPTIONS.es.PIN,
        "sim0_apn_name": "Nombre de APN",
        "sim0_apn_name.description": DESCRIPTIONS.es.APN_NAME,
        "sim0_apn_user": "Usuario de APN",
        "sim0_apn_user.description": DESCRIPTIONS.es.APN_USER,
        "sim0_apn_pass": "Contraseña de APN",
        "sim0_apn_pass.description": DESCRIPTIONS.es.APN_PASS,
        "sim1_band": "Banda",
        "sim1_band.description": DESCRIPTIONS.es.BAND,
        "sim1_pin": "PIN",
        "sim1_pin.description": DESCRIPTIONS.es.PIN,
        "sim1_apn_name": "Nombre de APN",
        "sim1_apn_name.description": DESCRIPTIONS.es.APN_NAME,
        "sim1_apn_user": "Usuario de APN",
        "sim1_apn_user.description": DESCRIPTIONS.es.APN_USER,
        "sim1_apn_pass": "Contraseña de APN",
        "sim1_apn_pass.description": DESCRIPTIONS.es.APN_PASS,
        // -
        "create.title": "Crear configuración de red",
        "edit.title": "Editar configuración de red",
    },
    en: {
        // QT-2G
        "pin.description": "PIN of the SIM card for unlocking. (4-digit code)",
        "apn_name": "APN name",
        "apn_name.description": "Name of the APN to use. (deactivate -1)",
        "apn_user": "APN user",
        "apn_user.description": "User of the APN to use. (deactivate -1)",
        "apn_password": "APN password",
        "apn_password.description": "Password of the APN to use. (deactivate -1)",
        // MQ2-4g
        "preference_sim": "SIM preference",
        "preference_sim.description": "Select the SIM preference to use. SIM 0 (chip), SIM 1 (external SIM)",
        "preference_sim.choices.preference_sim0": "Preferred SIM0",
        "preference_sim.choices.preference_sim1": "Preferred SIM1",
        "preference_sim.choices.only_sim0": "Only SIM0",
        "preference_sim.choices.only_sim1": "Only SIM1",
        "sim0_band": "Band",
        "sim0_band.description": DESCRIPTIONS.en.BAND,
        "band.choices.auto": "Automatic",
        "band.choices.preferred4g": "Preferred 4G",
        "band.choices.preferred2g": "Preferred 2G",
        "band.choices.only4g": "Only 4g",
        "band.choices.only2g": "Only 2g",
        "sim0_pin": "PIN",
        "sim0_pin.description": DESCRIPTIONS.en.PIN,
        "sim0_apn_name": "APN name",
        "sim0_apn_name.description": DESCRIPTIONS.en.APN_NAME,
        "sim0_apn_user": "APN user",
        "sim0_apn_user.description": DESCRIPTIONS.en.APN_USER,
        "sim0_apn_pass": "APN password",
        "sim0_apn_pass.description": DESCRIPTIONS.en.APN_PASS,
        "sim1_band": "Band",
        "sim1_band.description": DESCRIPTIONS.en.BAND,
        "sim1_pin": "PIN",
        "sim1_pin.description": DESCRIPTIONS.en.PIN,
        "sim1_apn_name": "APN name",
        "sim1_apn_name.description": DESCRIPTIONS.en.APN_NAME,
        "sim1_apn_user": "APN user",
        "sim1_apn_user.description": DESCRIPTIONS.en.APN_USER,
        "sim1_apn_pass": "APN password",
        "sim1_apn_pass.description": DESCRIPTIONS.en.APN_PASS,
        // -
        "create.title": "Create network configuration",
        "edit.title": "Edit network configuration",
    },
};

export default translations;
